import React from 'react';
import Services from '../../components/services/index';

const ServicesPage = () => {
  return (
    <>
      <Services />
    </>
  );
};

export default ServicesPage;
